import { render, staticRenderFns } from "./service-panel.vue?vue&type=template&id=3a6a7848&scoped=true&"
import script from "./service-panel.vue?vue&type=script&lang=ts&"
export * from "./service-panel.vue?vue&type=script&lang=ts&"
import style0 from "./service-panel.vue?vue&type=style&index=0&id=3a6a7848&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6a7848",
  null
  
)

export default component.exports